import React, { useEffect, useState } from "react";
import Index from "../../../Index";
import Paper from "@mui/material/Paper";
import PagesIndex from "../../../PagesIndex";

const Search = Index.styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: Index.alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: Index.alpha(theme.palette.common.white, 0.25)
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto"
  }
}));
const StyledInputBase = Index.styled(Index.InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch"
    }
  }
}));

const Reward = ({ rewardList }) => {
  const [page, setPage] = useState(0);
  const [filterData, setFilterData] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState("");

  
  useEffect(() => {
    setFilterData(rewardList);
  }, [rewardList]);
  const handleInputChange = (e) => {
    const newValue = e.target.value.trim().replace(/\s\s+/g, " ");
    setSearchValue(newValue);
    requestSearch(newValue);
  };

  const requestSearch = (searched) => {
    const searchTerm = searched.toLowerCase();

    const filtered = rewardList.filter((data) => {
      return (
        data?.coins?.toString()?.toLowerCase()?.includes(searchTerm) ||
        data?.transactionId?.movieId?.name?.toLowerCase()?.includes(searchTerm) ||
        data?.transactionId?.initTransId?.toString()?.includes(searchTerm) ||
        data?.transactionId?.paymentResponse?.amount?.toString()?.includes(searchTerm) ||
        (data?.createdAt &&
          moment(data?.createdAt).format("DD/MM/YYYY").includes(searchTerm))
      );
    });

    setFilterData(filtered);
    setPage(0); // Reset to first page
  };
  const handleClose = () => {
    setOpen(false);
    setViewPlan();
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Index.Box className="account-tab-booking-main">
      <Index.Box className="account-tab-heading-box">
        <Index.Box className="flex-align-member-search">
          <Index.Typography component="span" className="account-tab-heading">
            Rewards
          </Index.Typography>
          <Index.Box className="membership-search">
            <Search className="search">
              <StyledInputBase
                placeholder="Search"
                inputProps={{ "aria-label": "search" }}
                value={searchValue}
                onChange={handleInputChange}
              />
            </Search>
            <Index.Box className="search-icon-transaction">
              <Index.SearchIcon />
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>

      <Index.Box className="transaction-user-table">
        <Index.TableContainer
          component={Paper}
          className="user-transaction-container"
        >
          <Index.Table className="user-transaction-table">
            <Index.TableHead className="user-transaction-table-head">
              <Index.TableRow className="transaction-table-row">
                {/* <Index.TableCell className="transaction-table-cell" width="20%">
                  Subscription Id
                </Index.TableCell> */}
                <Index.TableCell className="transaction-table-cell" width="20%">
                  Date
                </Index.TableCell>
                <Index.TableCell className="transaction-table-cell" width="20%">
                  Movie Name
                </Index.TableCell>
                {/* <Index.TableCell
                    className="transaction-table-cell"
                    width="20%"
                  >
                    Cinema Name
                  </Index.TableCell> */}
                <Index.TableCell className="transaction-table-cell" width="20%">
                  Coins
                </Index.TableCell>
                {/* <Index.TableCell
                    className="transaction-table-cell"
                    width="20%"
                  >
                    Order Id
                  </Index.TableCell> */}
                <Index.TableCell className="transaction-table-cell" width="20%">
                  Booking Id
                </Index.TableCell>
                <Index.TableCell className="transaction-table-cell" width="20%">
                  Amount
                </Index.TableCell>
                {/* <Index.TableCell
                    className="transaction-table-cell"
                    width="20%"
                  >
                   Payment Status
                  </Index.TableCell> */}
                {/* <Index.TableCell
                    className="transaction-table-cell"
                    width="20%"
                  >
                   Booking Status
                  </Index.TableCell> */}
              </Index.TableRow>
            </Index.TableHead>
            <Index.TableBody className="transaction-table-body">
              {filterData?.length > 0 ? (
                filterData?.map((item, index) => {
                  console.log(item, "item323232");
                  return (
                    <Index.TableRow className="transaction-table-row">
                      <Index.TableCell className="transaction-table-cell">
                        {item?.createdAt
                          ? PagesIndex.moment(item?.createdAt).format(
                              "DD/MM/YYYY"
                            )
                          : "-"}
                      </Index.TableCell>
                      <Index.TableCell className="transaction-table-cell">
                        {item?.transactionId?.movieId?.name ? item?.transactionId?.movieId?.name : "-"}
                      </Index.TableCell>
                      <Index.TableCell className="transaction-table-cell">
                        {item?.coins ? item?.coins : "-"}
                      </Index.TableCell>
                      <Index.TableCell className="transaction-table-cell">
                        {item?.transactionId?.initTransId ? item?.transactionId?.initTransId: "-"}
                      </Index.TableCell>
                      <Index.TableCell className="transaction-table-cell">
                        {item?.transactionId?.paymentResponse?.amount ? item?.transactionId?.paymentResponse?.amount : "-"}
                      </Index.TableCell>
                    </Index.TableRow>
                  );
                })
              ) : (
                <Index.TableRow>
                  <Index.TableCell
                    component="td"
                    variant="td"
                    scope="row"
                    colSpan={5}
                    align="center"
                  >
                    No rewards available
                  </Index.TableCell>
                </Index.TableRow>
              )}
            </Index.TableBody>
          </Index.Table>
        </Index.TableContainer>

        <Index.TablePagination
          className="pagination-user-table"
          component="div"
          count={filterData?.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Index.Box>
    </Index.Box>
  );
};

export default Reward;
